import * as types from 'store/actions/types';
import services from 'services/services';

// Import helpers
import { getErrorCodeResults } from 'helpers/error_code_api';
import { getAffiliateClientQuery } from 'helpers/affiliate_client';

// ******************** REGISTER USER ********************
export const registerUser = (data) => async (dispatch) => {
	try {
		dispatch({
			type: types.REGISTER_USER_LOADING
		});

		// Get AffiliateClient ID query
		const query = getAffiliateClientQuery();

		const url = `/register${query}`;
		await services.post(url, { ...data, system: process.env.REACT_APP_SYSTEM });

		dispatch({
			type: types.REGISTER_USER_SUCCESS
		});
	} catch (error) {
		if (error.response) {
			const { codeErrorMessage } = getErrorCodeResults(error);
			// Dispatch an error action
			error.response.data.message = codeErrorMessage;
		}

		// Dispatch an error action
		dispatch({
			type: types.REGISTER_USER_ERROR,
			payload: error.response
		});

		throw error;
	}
};

// ******************** FETCH REGISTER AGREEMENTS ********************
export const fetchRegisterAgreements = () => async (dispatch) => {
	try {
		dispatch({
			type: types.FETCH_REGISTER_AGREEMENTS_LOADING
		});

		const url = 'register/agreements';
		const { data } = await services.get(url);

		dispatch({
			type: types.FETCH_REGISTER_AGREEMENTS_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_REGISTER_AGREEMENTS_ERROR
		});
	}
};

export const clearRegisterAgreements = () => (dispatch) => {
	dispatch({
		type: types.CLEAR_REGISTER_AGREEMENTS
	});
};

// ******************* Clear register data *******************
export const clearRegisterData = () => (dispatch) => {
	dispatch({
		type: types.CLEAR_REGISTER_DATA
	});
};
